import { IconDotsVertical, IconDownload, IconEdit, IconTrash } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import { useCallback, useState } from 'react';
import {
    Dropdown, DropdownItem, DropdownMenu, DropdownToggle,
} from 'reactstrap';
import './RecentDocumentCard.scss';
import { getFileIcon, iconColorByFilenameExtension } from 'views/DocumentLibrary/helpers';

interface IRecentDocumentCard {
    filename: string;
    selectDocument: () => void;
    uri?: string;
    dateModified?: string;
    format?: string;
    onDeleteDocument: () => void;
    onEditDocument: () => void;
}

const RecentDocumentCard = ({
    filename, uri, dateModified, format, selectDocument, onDeleteDocument, onEditDocument,
}: IRecentDocumentCard) => {
    const [openOptions, setOpenOptions] = useState(false);

    const handleOpenDocument = useCallback(() => {
        window.open(uri, '_blank');
    }, [uri]);

    const fileBadgeColorClass = `RecentDocumentCard__${iconColorByFilenameExtension[format!.toLowerCase()]}`;

    return (
        <div
            className="p-2 d-flex mt-1 mr-3 card RecentDocumentCard__container cursor--pointer"
            onClick={selectDocument}
            onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && selectDocument()}
            role="button"
            tabIndex={0}
            data-testid="recent-document-card"
        >
            <div className="d-flex align-items-center justify-content-between w-100">
                <div className="d-flex align-items-center text-truncate mr-2">
                    <div
                        className={`rounded d-flex align-items-center justify-content-center RecentDocumentCard__file-badge ${fileBadgeColorClass}`}
                    >
                        <NSIcon
                            icon={getFileIcon({ fileFormat: format, isExpanded: false })}
                            size="lg"
                            color="white"
                        />
                    </div>
                    <div className="ml-1 px-1 text-truncate">
                        <p className="m-0 text-white text-truncate">{filename}</p>
                        <span className="text-muted">{dateModified}</span>
                    </div>
                </div>
                <Dropdown isOpen={openOptions} toggle={() => setOpenOptions(!openOptions)} direction="down">
                    <DropdownToggle tag="div" onClick={e => e.stopPropagation()}>
                        <NSIcon className="cursor--pointer text-white" data-testid="ellipsis-icon" icon={IconDotsVertical} />
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem
                            data-testid="download-action"
                            className="text-white"
                            onClick={handleOpenDocument}
                        >
                            <div className="d-flex align-items-center justify-content-between w-100">
                                <span>Download</span>
                                <NSIcon icon={IconDownload} />
                            </div>
                        </DropdownItem>
                        <DropdownItem
                            data-testid="edit-action"
                            className="text-white"
                            onClick={onEditDocument}
                        >
                            <div className="d-flex align-items-center justify-content-between w-100">
                                <span>Edit</span>
                                <NSIcon icon={IconEdit} />
                            </div>
                        </DropdownItem>
                        <DropdownItem
                            data-testid="delete-action"
                            className="text-white"
                            onClick={onDeleteDocument}
                        >
                            <div className="d-flex align-items-center justify-content-between w-100">
                                <span>Delete</span>
                                <NSIcon icon={IconTrash} />
                            </div>
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        </div>
    );
};

export default RecentDocumentCard;
